var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", { domProps: { innerHTML: _vm._s(_vm.truncated) } }),
    _vm._v(" "),
    _vm.overflow
      ? _c("button", {
          staticClass: "expand",
          class: [_vm.truncate ? "" : "expanded"],
          on: {
            click: function ($event) {
              return _vm.toggle()
            },
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/ExpandText.vue